import { clsCat } from '@/styles/styles.utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes } from 'react';

export const buttonVariants = cva(
  clsCat({
    base: 'h-min',
    border: 'border rounded-lg',
    alignment: 'items-center',
    disabled: 'disabled:cursor-not-allowed disabled:bg-neutral-200',
    text: 'text-base font-medium',
  }),
  {
    variants: {
      intent: {
        primary: clsCat({
          background: 'bg-brand',
          text: 'text-neutral-0',
          border: 'border-none',
          hover: 'hover:bg-brand-700',
        }),
        secondary: clsCat({
          border: 'border-neutral-700',
          background: 'bg-transparent',
          text: 'text-neutral-700',
          hover: 'hover:bg-neutral-200',
        }),
        destructive: clsCat({
          base: 'bg-error-500',
          border: 'border-error-500',
          text: 'text-neutral-0',
        }),
      },
      variant: {
        fitted: 'w-auto',
        stretch: 'w-full',
        static: 'w-52',
      },
      size: {
        small: 'px-4 py-2',
        medium: 'px-8 py-3',
      },
    },
    defaultVariants: {
      intent: 'primary',
      variant: 'stretch',
      size: 'medium',
    },
  }
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>;
